import React from "react";
import "./index.scss";

const InputField = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  required = false,
  disabled = false,
  readOnly = false,
  maxLength,
  rows = 3,
  fullWidth = false,
  className = "",
  showEyeIcon = false,
  onEyeIconClick,
  isAadharVisible = false,
}) => {
  const wrapperClass = [
    "input-field-wrapper",
    fullWidth ? "full-width" : "",
    disabled ? "is-disabled" : "",
    error ? "has-error" : "",
    showEyeIcon ? "has-eye-icon" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const inputClass = [
    "input-field",
    disabled ? "disabled-field" : "",
    error ? "input-error" : "",
    showEyeIcon ? "with-icon" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClass}>
      {label && type !== "checkbox" && (
        <label className="input-label" htmlFor={name}>
          {label}
          {required && <span className="required-mark"> *</span>}
        </label>
      )}

      <div className="input-container">
        {type === "textarea" ? (
          <textarea
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            maxLength={maxLength}
            rows={rows}
            required={required}
            className={inputClass}
          />
        ) : type === "checkbox" ? (
          <label className="checkbox-label" htmlFor={name}>
            <input
              id={name}
              type="checkbox"
              name={name}
              checked={!!value}
              onChange={onChange}
              onBlur={onBlur}
              disabled={disabled}
              className="checkbox-input"
            />
            <span className="checkbox-text">{label}</span>
          </label>
        ) : (
          <input
            id={name}
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            maxLength={maxLength}
            required={required}
            className={inputClass}
          />
        )}

        {showEyeIcon && onEyeIconClick && (
          <button
            type="button"
            className={`eye-icon-button ${isAadharVisible ? "visible" : ""}`}
            onClick={onEyeIconClick}
            title={
              isAadharVisible
                ? "Hide Aadhar Number"
                : "View Aadhar Number (OTP Required)"
            }
          >
            {isAadharVisible ? (
              // Eye slash icon (visible)
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 3L21 21M10.584 10.587C10.2087 10.9623 9.99778 11.4716 9.99756 12.0018C9.99734 12.532 10.2078 13.0415 10.5828 13.4171C10.9578 13.7927 11.4671 14.0036 11.9973 14.0038C12.5275 14.004 13.037 13.7935 13.4126 13.4185M10.584 10.587L13.4126 13.4185M10.584 10.587L7.36396 7.36396M13.4126 13.4185L16.636 16.636M7.36396 7.36396C5.49396 8.68396 3.99996 10.72 2.45796 12.72C3.73096 14.49 5.23496 16.06 7.36396 16.636M7.36396 7.36396L16.636 16.636M16.636 16.636C18.506 15.316 20 13.28 21.542 11.28C20.269 9.51 18.765 7.94 16.636 7.364"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              // Eye icon (hidden)
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 5C7 5 2.73 8.11 1 12.5C2.73 16.89 7 20 12 20C17 20 21.27 16.89 23 12.5C21.27 8.11 17 5 12 5Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
        )}
      </div>

      {error && <span className="input-error-msg">{error}</span>}
    </div>
  );
};

export default InputField;
